import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { VERSION_CHECK_POLLING_INTERVAL } from './service/new-version.constants';
import { NewVersionService } from './service/new-version.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [NewVersionService],
})
export class NewVersionModule {
  static forRoot(polingInterval: string): ModuleWithProviders<NewVersionModule> {
    return {
      ngModule: NewVersionModule,
      providers: [
        {
          provide: VERSION_CHECK_POLLING_INTERVAL,
          useValue: polingInterval,
        },
      ],
    };
  }
}
